// AudioContext.tsx
import React, { createContext, useContext, useRef } from "react";
import clickSound from "../assets/sounds/click.wav";
import wrongSound from "../assets/sounds/wrong.wav";
import correctSound from "../assets/sounds/correct.mp3";

type AudioContextType = {
  playClickSound: (volume?: number) => void;
  playWrongOption: (volume?: number) => void;
  playCorrectSound: (volume?: number) => void;
};

const AudioContext = createContext<AudioContextType | undefined>(undefined);

export const AudioProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  const playClickSound = (volume = 0.2) => {
    if (audioRef.current) {
      audioRef.current.src = clickSound;
      audioRef.current.volume = volume;
      audioRef.current.play().catch((error) => {
        console.error("Sound play error", error);
      });
    }
  };

  const playWrongOption = (volume = 0.9) => {
    if (audioRef.current) {
      audioRef.current.src = wrongSound;
      audioRef.current.volume = volume;
      audioRef.current.play().catch((error) => {
        console.error("Sound play error", error);
      });
    }
  };

  const playCorrectSound = (volume = 0.6) => {
    if (audioRef.current) {
      audioRef.current.src = correctSound;
      audioRef.current.volume = volume;
      audioRef.current.play().catch((error) => {
        console.error("Sound play error", error);
      });
    }
  };

  return (
    <AudioContext.Provider
      value={{ playClickSound, playWrongOption, playCorrectSound }}
    >
      {children}
      <audio ref={audioRef} />
    </AudioContext.Provider>
  );
};

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error("useAudio must be used within an AudioProvider");
  }
  return context;
};
